export function RealtimeBadge({ connected }: { connected: boolean }) {
  return (
    <span
      className={`badge ${connected ? "badge--success" : "badge--warning"}`}
      title={
        connected
          ? "Terhubung realtime via WebSocket"
          : "Menyambung ulang ke WebSocket"
      }
    >
      {connected ? "Realtime" : "Menyambung..."}
    </span>
  );
}
